import React from "react";
import "../../../style/common/_spinner.scss";

const  FixedLoading = ({top = "0", left = "0", backgroundColor = "black"}) => {
  return (
    <div className="loading-list fixed" style={{top: top, left: left, backgroundColor: backgroundColor}}>
      <div className="loader loader-1" style={{top: "40%"}}></div>
    </div>
  )
};
export default FixedLoading;